import { render, staticRenderFns } from "./SetRangeHarga.vue?vue&type=template&id=5c609e2e"
import script from "./SetRangeHarga.vue?vue&type=script&lang=js"
export * from "./SetRangeHarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports